import * as React from 'react';
import './App.css';
import Router from "./Router";
import { UserContextProvider } from "./app/context/UserContext";
import { NetworkProvider } from "./app/context/NetworkContext";

const App = () => {
  return (
    <UserContextProvider>
      <NetworkProvider>
        <Router />
      </NetworkProvider>
    </UserContextProvider>
  );
};

export default App;

